import React from 'react'
import { Card } from 'antd'
import { useParams } from 'react-router'
import fileDownload from 'js-file-download'
import { useSelector } from 'react-redux'
import ConfidenceDistributionChart from './ConfidenceDistributionChart'
import { useLazyExportConfidenceDistributionQuery } from '../../../../../../../store/apis/analytics.api'
import assignmentSelectors from '../../../../../../../store/selectors/assignment.selectors'
import ExportDropdownButton from '../../../../../../../components/common/export/ExportDropdownButton'

const ConfidenceDistributionCard = () => {
    const { token } = useParams()
    const assignmentName = useSelector(assignmentSelectors.name)

    const [exportConfidenceDistribution, exportResult] = useLazyExportConfidenceDistributionQuery()

    const handleExport = async format => {
        const response = await exportConfidenceDistribution({ token, format })

        if ('data' in response) {
            const fileExtension = format.toLowerCase() === 'xlsx' ? 'xlsx' : 'csv'
            fileDownload(response.data, `${assignmentName}_confidence_distribution.${fileExtension}`)
        }
    }

    const extra = (
        <ExportDropdownButton
            onExport={handleExport}
            formats={['csv', 'xlsx']}
            loading={exportResult.isLoading}
            buttonText='Export'
        />
    )

    return (
        <Card title='Confidence Distribution' extra={extra}>
            <ConfidenceDistributionChart token={token} />
        </Card>
    )
}

export default ConfidenceDistributionCard
